import { render, staticRenderFns } from "./backGround.vue?vue&type=template&id=60f80370&scoped=true&"
import script from "./backGround.vue?vue&type=script&lang=js&"
export * from "./backGround.vue?vue&type=script&lang=js&"
import style0 from "./backGround.vue?vue&type=style&index=0&id=60f80370&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f80370",
  null
  
)

export default component.exports